import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../CommonComponents/AdvModal';
import { LinkButton } from '../../../CommonComponents/Button';

const remaining = text => 500 - text.length;

const NotesPopupView = ({
  clientId,
  goalId,
  subgoalId,
  isOpen,
  insuranceName,
  name,
  description,
  onSetDescription,
  shouldDrawDescriptionLabel,
  onSave,
  onDismiss,
  isLoading,
}) => (
  <Modal
    className="popup EditBreakdown"
    id="EditBreakdown"
    isOpen={isOpen}
    onRequestClose={onDismiss(clientId, goalId, subgoalId)}
    overlayClassName="closerdiv"
    shouldCloseOnOverlayClick={false}
  >
    <h2 className="title">
      Edit {insuranceName} Recommendation
      <LinkButton
        prependIcon="fa fa-times close"
        onClick={onDismiss(clientId, goalId, subgoalId)}
      />
    </h2>

    <form className="adv-form">
      <ul className="horizontal-layout">
        <li>
          {shouldDrawDescriptionLabel && <label>Edit Description for {name}</label>}
          <textarea
            name="Description"
            value={description}
            onChange={onSetDescription(clientId, goalId, subgoalId)}
          />
          <p className="character_counter">
            <span className={`${remaining(description) < 0 ? 'neg' : ''}`}>
              {remaining(description)}
            </span>{' '}
            characters remaining
          </p>
        </li>
      </ul>
    </form>
    <div className="actions">
      <button
        type="button"
        className={`rhs ${remaining(description) < 0 ? ' gray' : ' green'}${
          isLoading ? ' loading' : ''
        }`}
        id="btn-save"
        disabled={remaining(description) < 0}
        onClick={onSave(clientId, goalId, subgoalId, name, description)}
      >
        Save Changes
      </button>
      <button
        type="button"
        className="secondary dismiss lhs"
        onClick={onDismiss(clientId, goalId, subgoalId)}
        id="btn-cancel"
      >
        Cancel
      </button>
    </div>
  </Modal>
);

NotesPopupView.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  shouldDrawDescriptionLabel: PropTypes.bool.isRequired,
  clientId: PropTypes.string.isRequired,
  goalId: PropTypes.string.isRequired,
  subgoalId: PropTypes.string.isRequired,
  insuranceName: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onSetDescription: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default NotesPopupView;
